"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dayNumberToString = dayNumberToString;
exports.numbersToPersian = numbersToPersian;
function dayNumberToString(day) {
    switch (day) {
        case '0':
            return 'یکشنبه';
        case '1':
            return 'دوشنبه';
        case '2':
            return 'سه شنبه';
        case '3':
            return 'چهارشنبه';
        case '4':
            return 'پنجشنبه';
        case '5':
            return 'جمعه';
        case '6':
            return 'شنبه';
        default:
            return '';
    }
}
function numbersToPersian(str) {
    if (!str) {
        return str;
    }
    str = String(str);
    let newValue = '';
    for (let i = 0; i < str.length; i++) {
        const ch = str.charCodeAt(i);
        if (ch >= 48 && ch <= 57) {
            const newChar = ch + 1584;
            newValue += String.fromCharCode(newChar);
        }
        else {
            newValue += String.fromCharCode(ch);
        }
    }
    return newValue;
}
